import { render, staticRenderFns } from "./employee-panel.vue?vue&type=template&id=2c2bb04e&scoped=true&"
import script from "./employee-panel.vue?vue&type=script&lang=js&"
export * from "./employee-panel.vue?vue&type=script&lang=js&"
import style0 from "./employee-panel.vue?vue&type=style&index=0&id=2c2bb04e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2bb04e",
  null
  
)

export default component.exports